

























import { Component, Prop, Vue } from "vue-property-decorator";

import PortfolioCard from "@/components/pages/user/portfolio/PortfolioCard.vue";

@Component({
    components: { PortfolioCard },
})
export default class PortfolioList extends Vue {
    private portfolioList: any = [];
    private userId = this.$route.params.channel_id;

    async created() {
        // this.portfolioList = await this.$api.portfolioList("123");
    }
}
